import Driver from '@didi/gtr-driver.js'
import '@didi/gtr-driver.js/dist/driver.min.css'
import '@/plugins/driver/driver.scss'
import VueI18n from '@/i18n/locale'
import { gtrSendEvents } from '@/micro-app'

const GTR_DRIVER_FLAG = 'GTR_DRIVER_FLAG_STORAGE'

// 实践处理
function sendDriverEvent(eventType, data) {
  // 透传默认事件
  gtrSendEvents.GTR_EVENT_SEND_DRIVER({
    eventType,
    current: data,
  })
}
function getDriverInstance() {
  // https://git.xiaojukeji.com/wangbingyang/driver.js
  return new Driver({
    stageClassName: 'gtr-stage-class',
    animate: true, // 高亮元素改变时是否显示动画 Animate while changing highlighted element
    opacity: 0.6, // 背景透明度(0 表示只有弹窗并且没有遮罩) Background opacity (0 means only popovers and without overlay)
    padding: -2, //  元素与边缘的距离 Distance of element from around the edges
    nextBtnText: VueI18n.t('Gattaran_Homepage__PTEn' /* 下一步 */), // 当前步骤下一步按钮上的文本 Next button text for this step
    prevBtnText: VueI18n.t('Gattaran_Homepage__lnWD' /* 上一步 */),
    doneBtnText: VueI18n.t('Gattaran_Homepage__FxHz' /* 我知道了 */),
    allowClose: false,
    onPrevious(evt) {
      sendDriverEvent('onPrevious', evt)
    },
    onNext(evt) {
      sendDriverEvent('onNext', evt)
    },
    onReset(evt) {
      sendDriverEvent('onReset', evt)
    },
    onDeselected(evt) {
      sendDriverEvent('onDeselected', evt)
    },
    onFinish(evt) {
      sendDriverEvent('onFinish', evt)
    },
  })
}

export default function () {
  // 放外面翻译更新不及时
  const DriverSteps = [
    {
      element: '#gtr-header_recently',
      popover: {
        title: VueI18n.t('Gattaran_Homepage__Tchu' /* 最近访问 */),
        description: VueI18n.t(
          'Gattaran_Homepage__IEfB' /* 最近访问陈列的是你近期访问过的功能，是一个快捷访问入口 */,
        ),
        position: 'bottom-left  ',
      },
    },
    {
      element: '#pebble-pro-layout-nav_menu',
      popover: {
        title: VueI18n.t('Gattaran_Homepage__HCuT' /* 主导航 */),
        description: VueI18n.t(
          'Gattaran_Homepage__SbiO' /* 产品已按照业务场景重新分类，来熟悉新的分类方式吧，还可以发现更多有帮助的功能 */,
        ),
        position: 'bottom',
      },
    },
    {
      element: '#gtr-layout-nav_function',
      popover: {
        title: VueI18n.t('Gattaran_Homepage__VxjE' /* 工具栏 */),
        description: VueI18n.t(
          'Gattaran_Homepage__Fkve' /* 工具栏是一组Gattaran工具的集合，你可以在这里设置国家、语言，查看消息通知，反馈问题 */,
        ),
        position: 'bottom',
      },
    },
    {
      element: '#gtr-workshop_profile',
      popover: {
        title: VueI18n.t('Gattaran_Homepage__kLUb' /* 个人中心 */),
        description: VueI18n.t(
          'Gattaran_Homepage__qJVu' /* 我的申请、我的角色、我的审核的入口移动到这里了 */,
        ),
        position: 'bottom-right',
      },
    },
    {
      element: '#pebble-pro-layout-nav_logo',
      popover: {
        title: VueI18n.t('Gattaran_Homepage__bYLT' /* 首页 */),
        description: VueI18n.t('Gattaran_Homepage__ybCE' /* 在首页，你可以查看Gattaran系统全貌 */),
        position: 'bottom',
      },
    },
  ]
  setTimeout(() => {
    window.gtr_driverInstance = getDriverInstance()

    // Define the steps for introduction
    window.gtr_driverInstance.defineSteps(DriverSteps)
  }, 0)
  // Start the introduction
  const start = () => {
    setTimeout(() => {
      const flag = window.localStorage.getItem(GTR_DRIVER_FLAG)
      if (flag) return
      window.gtr_driverInstance.start(0)
      window.localStorage.setItem(GTR_DRIVER_FLAG, new Date().toDateString())
    }, 100)
  }
  const clear = () => {
    window.localStorage.removeItem(GTR_DRIVER_FLAG)
  }
  const reStart = () => {
    clear()
    // driverInstance = getDriverInstance()
    window.gtr_driverInstance.refresh()
    window.gtr_driverInstance.reset()
    setTimeout(() => {
      window.gtr_driverInstance.start(0)
      window.localStorage.setItem(GTR_DRIVER_FLAG, new Date().toDateString())
    })
  }
  return {
    start,
    clear,
    reStart,
  }
}
